<template>
  <div class="page">
    <h3 class="fc-text-sm fc-color-gray-light fc-pad-t-big fc-pad">{{$t('m.common-problem')}}</h3>
    <div class="fc-text-usual fc-bg-fff fc-pad fc-pad-t-sm fc-color-gray-dark">
      <p class="fc-pad-b-min">{{$t('m.whether-account')}}</p>
      <p class="fc-color-gray-light">{{$t('m.answer-whether-account')}}</p>
      <hr class="hr-line" />
      <p class="fc-pad-b-min">{{$t('m.no-account')}}</p>
      <p class="fc-color-gray-light">{{$t('m.answer-no-account')}}</p>
      <p class="fc-color-gray-light">{{$t('m.recharge-money')}}</p>
      <p class="fc-color-gray-light">{{$t('m.recharge-time')}}</p>
      <p class="fc-color-gray-light">{{$t('m.recharge-shot')}}</p>
      <hr class="hr-line" />
      <p class="fc-pad-b-min">{{$t('m.recharge-wrong')}}</p>
      <p class="fc-color-gray-light">{{$t('m.answer-recharge-wrong')}}</p>
      <hr class="hr-line" />
      <p class="fc-pad-b-min">{{$t('m.refund')}}</p>
      <p class="fc-color-gray-light">{{$t('m.answer-refund')}}</p>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'asks',
    data() {
      return {

      }
    },
    watch: {

    },
    filters: {

    },
    mounted() {
      this.getLang();
      this.textSize();
    },
    methods: {
      //字体大小
      textSize() {
        ! function(a) {
          function b() {
            var b = g.getBoundingClientRect().width;
            a.rem = (b / 7.5 > 100 ? 100 : (b / 7.5 < 300 / 7.5 ? 300 / 7.5 : b / 7.5)), g.style.fontSize = a.rem +
              "px"
            //a.rem = (b / 7.5), g.style.fontSize = a.rem + "px"
          }
          var g = a.document.documentElement,
            e;
          a.addEventListener("resize", function() {
            clearTimeout(e), e = setTimeout(b, 300)
          }, !1), a.addEventListener("pageshow", function(a) {
            a.persisted && (clearTimeout(e), e = setTimeout(b, 300))
          }, !1), b()
        }(window);
      },
      getLang() {
        var box = document.getElementById("app");
        let language = navigator.language || navigator.browserLanguage;
        if (language == 'ar') {
          box.style.direction = 'rtl';
        } else {
          box.style.direction = 'ltr';
        }
      },

    },

  }
</script>

<style scoped>
  @import url("../assets/css/common.css");
  .page {
    background: #F7F7F7;
    line-height: .48rem;
  }

  .hr-line {
    border: 0.01rem solid #F3F3F3;
    margin: .18rem 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/asks.vue